<template>
  <div>
    <v-list-tile
      :key="student.id"
      avatar
    >
      <v-list-tile-avatar color="primary">
        <img v-if="student.picture"
          class="img"
          :src="student.picture"
          :alt="student.name"
        >
        <v-icon v-else dark>account_circle</v-icon>
      </v-list-tile-avatar>

      <v-list-tile-content>
        <v-list-tile-title v-text="student.name"/>
      </v-list-tile-content>
    </v-list-tile>
    <v-divider class="divider-color"/>
  </div>
</template>

<script>

export default {
  name: 'studentListConfirmation',

  props: {
    student: {
      type: Object,
      default: () => {
        return {}
      }
    }
  }
}
</script>
